import React, { FC, useEffect, useState } from 'react'

import { ButtonContainer, Page, PageContent } from 'common'
import { Header } from 'components'
import { Button } from 'common/styles/layouts'
import { IS_SEND_DOCUMENTS_ENABLED } from 'pages/my-services/utils/constants'

import { SelectBottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Textarea } from '@interco/inter-ui/components/Textarea'
import { Upload } from '@interco/inter-ui/components/Upload'
import { Text } from '@interco/inter-ui/components/Text'

import {
  FormInputContainer,
  NewServiceViewContainer,
  TextAreaContainer,
  UploadContainer,
} from '../styles/NewService.styles'
import { TNewServiceContent } from '../types/NewService.types'

export const NewServiceView: FC<TNewServiceContent> = ({
  title,
  select,
  options,
  selectedValue,
  textArea,
  upload,
  textValue,
  textInfo,
  sendSupportButtonLabel,
  isSendButtonDisabled,
  isLoading,
  isEditService,
  hasScroll,
  customRef,
  errorOnFiles,
  uploadPercentage,
  onChange,
  onChangeText,
  onSelectFiles,
  onSendRequest,
  onDelete,
  onUpdateRequest,
}) => {
  const [isInitialTouchBlocked, setIsInitialTouchBlocked] = useState(true)

  useEffect(() => {
    const blurActiveElement = () => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
    }

    blurActiveElement()

    const timeoutId = window.setTimeout(() => {
      blurActiveElement()
      setIsInitialTouchBlocked(false)
    }, 400)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [])

  const handleSubmitClick = (event?: React.MouseEvent<HTMLButtonElement>) => {
    if (isInitialTouchBlocked) {
      event?.preventDefault()
      event?.stopPropagation()
      return
    }

    event?.currentTarget.blur()

    if (isEditService) onUpdateRequest()
    else onSendRequest()
  }

  return (
    <Page>
      {title && <Header title={title} />}
      <NewServiceViewContainer>
        <PageContent ref={customRef}>
          <FormInputContainer>
            {select && options && (
              <SelectBottomSheet
                id="select"
                label={select.title}
                placeholder={select.placeholder}
                value={selectedValue}
                options={options}
                onChange={onChange}
                className="selectBottomSheet"
                disabled={isEditService}
              />
            )}
          </FormInputContainer>
          <FormInputContainer>
            {textArea && (
              <TextAreaContainer>
                <Textarea
                  label={textArea.title}
                  placeholder={textArea.placeholder}
                  value={textValue}
                  onChange={(event) => {
                    onChangeText(event.target.value)
                  }}
                  maxLength={textArea.limit}
                  id="textarea"
                  disabled={isEditService}
                />
                <Text variant="body-3">{textInfo}</Text>
              </TextAreaContainer>
            )}
          </FormInputContainer>
          {IS_SEND_DOCUMENTS_ENABLED && (
            <UploadContainer>
              {upload && <Text variant="body-3">{upload.observation}</Text>}
              {upload && (
                <Upload
                  id="upload"
                  title={upload.title}
                  subtitle={upload.subtitle}
                  onChange={onSelectFiles}
                  onDelete={onDelete}
                  onCancel={onDelete}
                  progressPercentage={uploadPercentage}
                  error={errorOnFiles}
                  mode="file"
                  accept={['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf']}
                  showProgressBar={uploadPercentage !== 0}
                />
              )}
            </UploadContainer>
          )}
          <ButtonContainer $hasScroll={hasScroll}>
            <Button
              fullWidth
              isLoading={isLoading}
              disabled={isSendButtonDisabled || isInitialTouchBlocked}
              onClick={handleSubmitClick}
            >
              {sendSupportButtonLabel}
            </Button>
          </ButtonContainer>
        </PageContent>
      </NewServiceViewContainer>
    </Page>
  )
}
